// Detección de ruido no-accionable para el Sentry del front.
//
// Módulo PURO (sin imports): la lógica de descarte vive aquí para poder
// testearla con Node contra fixtures de eventos reales
// (spec/javascript/sentry_noise_spec.mjs) — lección de ARCADI-E7: la primera
// versión del filtro usaba ignoreErrors, que solo compara el MENSAJE del
// error, y estos patrones no viven en el mensaje (el de E7 es "undefined is
// not an object (evaluating 'window.webkit.messageHandlers')"); viven en los
// STACK FRAMES del script que Meta inyecta. Resultado: 46 eventos "filtrados"
// que siguieron llegando. Un filtro sin test contra el evento real es un deseo.

// El navegador embebido de Instagram/Facebook inyecta su telemetría en cada
// página y su puente nativo falla solo. Señales, tomadas de los eventos
// reales de ARCADI-E7 (iOS) y E8 (Android):
// - function "sendDataToNative" en algún frame (ambas plataformas; cero
//   menciones de ese símbolo en nuestro código).
// - filename/abs_path con esquema "iabjs://" (el in-app browser de Meta en
//   Android).
// OJO: NO filtrar por filename http(s) — los scripts inline inyectados
// heredan la URL de NUESTRO documento (comprobado en E7: filename
// "https://www.arcadienvios.com/"). Y NO filtrar por mensajes genéricos de
// webview ("window.webkit.messageHandlers"): el miniapp de TPaga (partner)
// también es un webview y sus errores son señal de integración (ARCADI-ED/EE)
// que queremos seguir viendo.
const META_FRAME_FUNCTION = /sendDataToNative/i;
const META_FRAME_SCHEME = /^iabjs:\/\//i;

export function isThirdPartyWebviewNoise(event) {
  const frames = (event?.exception?.values || []).flatMap(
    (exception) => exception.stacktrace?.frames || [],
  );
  return frames.some(
    (frame) =>
      META_FRAME_FUNCTION.test(frame.function || '') ||
      META_FRAME_SCHEME.test(frame.filename || '') ||
      META_FRAME_SCHEME.test(frame.abs_path || ''),
  );
}

// "Network Error" de axios con el navegador CONFIRMANDO que está offline: es
// conectividad del usuario, imposible de accionar. Con el usuario ONLINE se
// reporta igual — un Network Error online puede ser caída NUESTRA (server
// inalcanzable, DNS, SSL, CORS) y ahí sí queremos la alarma (criterio
// acordado para no cegarnos ante outages; contexto: ARCADI-E9).
export function isOfflineNetworkError(event) {
  const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
  if (!offline) return false;
  return (event?.exception?.values || []).some(
    (exception) => typeof exception.value === 'string' && exception.value.includes('Network Error'),
  );
}

// Aborts de navegación: el usuario dejó la página con requests en vuelo. Dos
// formas del mismo no-evento (ARCADI-EG): el "Request aborted" de axios
// (ECONNABORTED vía request.onabort) y el rechazo "Phantom response (status
// 0)" que nuestro interceptor emite cuando el XHR abortado llega como éxito
// vacío. Ninguno es accionable: el usuario ya no está en la página. OJO: NO
// filtrar "Network Error" aquí — eso tiene su propio criterio (solo offline
// confirmado, arriba), porque online puede ser caída NUESTRA.
// OJO doble: (1) el TIMEOUT de axios comparte código ECONNABORTED con el
// abort pero su mensaje es 'timeout of Nms exceeded' — NO está aquí a
// propósito: un timeout con el usuario online es señal de lentitud NUESTRA.
// (2) linkedErrors expande cadenas error.cause en exception.values: se
// descarta solo si TODA la cadena son marcadores de abort — un crash real
// que solo ENVUELVE un abort como causa sigue pasando.
const NAVIGATION_ABORT_VALUES = ['Request aborted', 'Phantom response (status 0)'];

export function isNavigationAbortNoise(event) {
  const values = event?.exception?.values || [];
  if (values.length === 0) return false;
  return values.every(
    (exception) => typeof exception.value === 'string'
      && NAVIGATION_ABORT_VALUES.some((marker) => exception.value.includes(marker)),
  );
}
